












































import { Component, Vue } from 'vue-property-decorator'
import PromotionTop from './components/promotion_top.vue'
import PromotionSeckillItem from './components/promotion_seckill_item.vue'
import PromotionGroupItem from './components/promotion_group_item.vue'
import { setShareInfo } from '@utils/index'

import { getSelectedCity } from '@utils/index'
import { getPanicBuyCMS, PromotionCMSResponse, getPanicBuyList, PanicBuyResponse } from './promotion-service'
import { City } from '@/app/core/constant'

@Component({
  components: {
    PromotionTop,
    PromotionSeckillItem,
    PromotionGroupItem
  }
})
export default class PanicBuy extends Vue {
  city: City | null = null
  config: PromotionCMSResponse | null = null //标题
  promotion: PanicBuyResponse | null = null //促销商品
  errormsg = '' //不为空 就实现错误页面
  moreSeckill = false //查看更多秒杀
  moreGroup = false //查看更多拼团

  async created() {
    this.city = await getSelectedCity()
    this.config = await getPanicBuyCMS()
    this.$tracker('127', '121012979')({ citycode: this.city.cityId })
    this.$setTitle(this.config.title)
    this.setShare()

    this.getPanicBuyData()
  }

  async getPanicBuyData() {
    try {
      const cityId = this.city?.cityId //城市编码
      const { spuId = '' } = this.$route.query
      const params = {
        cityId: cityId || '',
        spuId: spuId as string
      }
      this.promotion = await getPanicBuyList(params)
      if (this.showEmpty) {
        this.errormsg = '暂无相关信息哦～'
      }
    } catch (error) {
      this.errormsg = error
    }
  }

  async setShare() {
    const shareInfo = {
      title: this.config?.title,
      desc: this.config?.shareDes,
      imgUrl: this.config?.shareImg
    }
    setShareInfo(shareInfo)
    window.isActivePage = function() {
      return 1
    }
  }

  cityChoose() {
    this.$newClickTracker({bizType:'127',pageLevelId:'121012979',clickId:'200002',pageParam:{ 'citycode': this.city?.cityId },positionParam:{ 'citycode': this.city?.cityId }})
    this.$router.push({ name: 'city-choose', query: { referer: encodeURIComponent(location.href) , refresh: 'no' } })
  }

  clicked(info:any) {
    this.$newClickTracker({bizType:'127',pageLevelId:'121012979',clickId:'200001',pageParam:{ 'citycode': this.city?.cityId },positionParam:{ 'skutype': info.templateType2Id,'spuid': info.spuId }})
  }

  get showEmpty() {
    const top = this.promotion?.top
    const seckill = this.promotion?.seckill
    const group = this.promotion?.group
    if (top || (seckill && seckill.length > 0) || (group && group.length > 0)) {
      return false
    }
    return true
  }

  get seckillList() {
    const seckill = this.promotion?.seckill
    if (seckill && seckill.length > 0) {
      if (this.moreSeckill) {
        return seckill
      } else {
        const length = seckill.length > 10 ? 10 : seckill.length
        return seckill.slice(0, length)
      }
    }
    return []
  }

  get groupList() {
    const group = this.promotion?.group
    if (group && group.length > 0) {
      if (this.moreGroup) {
        return group
      } else {
        const length = group.length > 10 ? 10 : group.length
        return group.slice(0, length)
      }
    }
    return []
  }
}
